<template>
    <div>
        <label class="games-filter__option-dialog-label" v-for="(sortType, index) in filterOptions" :key="index">
            <input :id="'sort-option-' + index" type="radio" @click="selectFilter(sortType)" />
            {{ getFilterSortTypeLabel(sortType) }}
        </label>
    </div>
</template>

<script lang="ts" setup>
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { useGamesGrid } from "@/games/composables/use-games-grid";
import { GamesFilterSortType } from "@/games/models/games-filter-parameters";

const emit = defineEmits(["sortApplied"]);

const { reloadWithFilter, filterParameters, getFilterSortTypeLabel } = useGamesGrid();

const filterOptions = [GamesFilterSortType.Newest, GamesFilterSortType.Oldest, GamesFilterSortType.MostPlayed];

const selectFilter = async (type: GamesFilterSortType) => {
    filterParameters.value.sortType = type;
    await reloadWithFilter();
    emit("sortApplied");
    GamesAnalytics.pushSort(getFilterSortTypeLabel(type));
};
</script>
